import React, {useContext} from 'react';

import {pushQueryParams} from 'client/history';

import {MetricsSelector} from 'client/Reports/MetricsSelector/MetricsSelector.react';

import {ReportsContext} from '../../Reports.context';

export default function Metrics() {
  const {metrics, variables, dimensions, topLevelFilterType} = useContext(ReportsContext);

  const metricKeys = metrics.map((m) => m.key);

  return (
    <MetricsSelector
      dimensions={dimensions}
      filters={variables}
      topLevelFilterType={topLevelFilterType}
      isSelected={(option) => metricKeys.includes(option.key)}
      onSelect={(option) => {
        const metricKey = option.key;
        const updatedMetrics = metricKeys.includes(metricKey)
          ? metrics.filter((m) => m.key !== metricKey)
          : [...metrics, option];
        pushQueryParams({
          metrics: updatedMetrics.map((m) => m.key).join(','),
          sort: null
        });
      }}
    />
  );
}
